import {createSlice} from '@reduxjs/toolkit'

export const allProspectsDataSlice = createSlice({
  name: 'prospectSegmentation',
  initialState: {
    prospectList: {
      prospects: []
    },
    getSavedList: {
      savedLists: []
    },
    getGenerateEmailRow: {},
    contentSummary: [],
    selectedOppurtunity: [],
    opportunityListData: [],
    sortConfig: {direction: 'asc', key: null},
    sortDirection: 'asc',
    sortColumn: null
  },
  reducers: {
    getAllProspectsData: (state, action) => {
      state.prospectList.prospects = action.payload
    },
    getAllSavedProspectsData: (state, action) => {
      state.getSavedList.savedLists = action.payload
    },
    setGenerateEmailRowData: (state, action) => {
      state.getGenerateEmailRow = action.payload
    },
    setProspectContentSummary: (state, action) => {
      state.contentSummary.push(action.payload)
    },
    removeExisitingProspectContentSummary: (state, action) => {
      const removedSummary = state.contentSummary.filter((item) => item.id !== action.payload)
      state.contentSummary = removedSummary
    },
    removeAllProspectContentSummary: (state, action) => {
      state.contentSummary = action.payload
    },
    setSelectedOppurtunity: (state, action) => {
      state.selectedOppurtunity = action.payload
    },
    setOpportunityList: (state, action) => {
      state.opportunityListData = action.payload
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload
    },
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload
    },
    setSortConfig: (state, action) => {
      state.sortConfig = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {
  getAllProspectsData,
  getAllSavedProspectsData,
  setGenerateEmailRowData,
  setProspectContentSummary,
  removeExisitingProspectContentSummary,
  removeAllProspectContentSummary,
  setSelectedOppurtunity,
  setOpportunityList,
  setSortDirection,
  setSortColumn,
  setSortConfig
} = allProspectsDataSlice.actions

export default allProspectsDataSlice.reducer
